import { render, staticRenderFns } from "./H2HTable.vue?vue&type=template&id=e39fd8dc&scoped=true&"
import script from "./H2HTable.vue?vue&type=script&lang=js&"
export * from "./H2HTable.vue?vue&type=script&lang=js&"
import style0 from "./H2HTable.vue?vue&type=style&index=0&id=e39fd8dc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39fd8dc",
  null
  
)

export default component.exports